import { SWR_KEYS } from '@bulknutrients/bulk-shared-lib/constants';

import type { RegisteringCustomer } from '@bulknutrients/bulk-shared-lib/interfaces/Customer';
import type { SignUpAPIResponse } from 'pages/api/customer/sign-up';
import { useSWRConfig } from 'swr';

export function useSignup() {
  const { mutate } = useSWRConfig();

  return async (details: RegisteringCustomer) => {
    const customer: SignUpAPIResponse = await fetch('/api/customer/sign-up', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(details),
    }).then((res) => res.json());

    mutate(SWR_KEYS.customer);

    return customer;
  };
}
